export default __webpack_public_path__ + "static/media/removeLoansIcons.68803d04.svg";